import { render, staticRenderFns } from "./m-preview.vue?vue&type=template&id=28f93bf7&scoped=true"
import script from "./m-preview.vue?vue&type=script&lang=js"
export * from "./m-preview.vue?vue&type=script&lang=js"
import style0 from "./m-preview.vue?vue&type=style&index=0&id=28f93bf7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f93bf7",
  null
  
)

export default component.exports